import { render, staticRenderFns } from "./m-action-chips.vue?vue&type=template&id=718debec&scoped=true&"
import script from "./m-action-chips.vue?vue&type=script&lang=js&"
export * from "./m-action-chips.vue?vue&type=script&lang=js&"
import style0 from "./m-action-chips.vue?vue&type=style&index=0&id=718debec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718debec",
  null
  
)

export default component.exports